import type React from 'react';
import { useState } from 'react';

import { CopyButton, Tooltip } from '@vlabs/uikit';

import { TruncatedValue } from '@vlabs/monokit/shared/ui/truncated-value';

import st from './RoleIdCell.module.sass';

interface RoleIdCellProps {
  copiedTitle: string;
  copyTitle: string;
  roleId: string;
}

function RoleIdCell({
  copiedTitle,
  copyTitle,
  roleId,
}: RoleIdCellProps): React.JSX.Element {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <div
      className={st.Root}
      onMouseLeave={() => setIsCopied(false)}
    >
      <div className={st.Text}>
        <TruncatedValue value={roleId} />
      </div>

      <Tooltip
        position="bottom"
        tooltipContent={isCopied ? copiedTitle : copyTitle}
      >
        <CopyButton
          className={st.CopyButton}
          onClickCapture={() => setIsCopied(true)}
          size="small"
          value={roleId}
        />
      </Tooltip>
    </div>
  );
}

export { RoleIdCell };
